// Draft recovery utilities for session expiration handling

const DRAFT_STORAGE_KEY = 'covenant_command_draft';
const LAST_ROUTE_KEY = 'covenant_command_last_route';

export const saveDraft = (formData, userId, route) => {
  try {
    const draft = {
      formData,
      userId,
      route,
      timestamp: new Date().toISOString(),
      expiresAt: new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString() // 24 hours
    };
    localStorage.setItem(DRAFT_STORAGE_KEY, JSON.stringify(draft));
    localStorage.setItem(LAST_ROUTE_KEY, route);
    console.log('Draft saved:', draft);
  } catch (error) {
    console.error('Error saving draft:', error);
  }
};

export const getDraft = (userId) => {
  try {
    const draftStr = localStorage.getItem(DRAFT_STORAGE_KEY);
    if (!draftStr) return null;

    const draft = JSON.parse(draftStr);
    
    // Check if draft has expired
    if (new Date(draft.expiresAt) < new Date()) {
      clearDraft();
      return null;
    }

    // Check if draft belongs to current user
    if (draft.userId !== userId) {
      return null;
    }

    return draft;
  } catch (error) {
    console.error('Error getting draft:', error);
    return null;
  }
};

export const clearDraft = () => {
  try {
    localStorage.removeItem(DRAFT_STORAGE_KEY);
  } catch (error) {
    console.error('Error clearing draft:', error);
  }
};

export const getLastRoute = () => {
  try {
    return localStorage.getItem(LAST_ROUTE_KEY) || '/';
  } catch (error) {
    console.error('Error getting last route:', error);
    return '/';
  }
};

export const clearLastRoute = () => {
  try {
    localStorage.removeItem(LAST_ROUTE_KEY);
  } catch (error) {
    console.error('Error clearing last route:', error);
  }
};
